import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';
import ContainerDefault from '../../components/ContainerDefault';
import { Loading } from '../../components/UtilComponent';
import * as agricultorAction from '../../services/agricultor/Action';
import * as Constants from '../../utils/constants';
import FormMotorista from './components/FormAgricultor';

class MotoristaContainer extends Component {

    constructor() {
        super();
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        if (this.props.match.params.id)
            this.props.action.getAgricultorByIdAction(this.props.match.params.id);
    }

    handleCancel(event) {
        event.preventDefault();
        this.props.history.replace(Constants.ROUTE_URL_AGRICULTORES);
    }

    handleSave(values) {
        return this.props.action.saveAgricultorAction(values).then((agricultorObject) => {
            setTimeout(() => {                 
                this.props.history.replace(Constants.ROUTE_URL_AGRICULTORES);
            }, 1000)
        }).catch((error) => {
            throw new SubmissionError(error);
        });
    }
    retornarDadosTela() {
        const { agricultorObject, messages, messageSuccess, isLoading } = this.props;


        if (isLoading) return (
            <Loading title={Constants.DESCRICAO_PESSOA} />
        );

        return (<ContainerDefault
            title={Constants.DESCRICAO_NOVO_PESSOA}
            messages={messages}
            messageSuccess={messageSuccess}
            container={
                <FormMotorista
                    initialValues={agricultorObject}
                    handleSave={this.handleSave}
                    handleCancel={this.handleCancel}
                    heading={'Adicionar'}
                />
            } />);

    }

    render() {
        return this.retornarDadosTela();
    }
};

const mapStateToProps = state => ({
    agricultorObject: state.agricultorReducer.agricultorObject,
    messages: state.messageResponseReducer.messages,
    messageSuccess: state.messageResponseReducer.messageSuccess,
    isLoading: state.apiReducer.isLoading

});

const mapDispatchToProps = dispatch => ({
    action: bindActionCreators(agricultorAction, dispatch)
});



export default connect(mapStateToProps, mapDispatchToProps)(MotoristaContainer);